import React from 'react'

const About = () => {
  return (
    <div>Still Working on this ya habeeb a5ook</div>
  )
}

export default About